import ParserModule from "../ParserModule";
export default class EmbeddedBufferModule extends ParserModule {
    loadBufferResource(tf) {
        if (this.__isDataUri(tf.uri)) {
            return Promise.resolve(this.__dataUriToArrayBuffer(tf.uri));
        }
    }
}



// WEBPACK FOOTER //
// ./src/Parser/Modules/EmbeddedBufferModule.ts